'use client';
import HeaderLogo from '@/assets/icons/radius_qora_logo.svg';
import IconArrow from '@/assets/icons/icon-arrow-down.svg';
import { CustomCitiesSelect, HeaderTopMobile } from '@/components';
import { MenuDetailsFragment } from '@/graphql';
import useHasMounted from '@/hooks/useHasMounted';
import { Link, usePathname, useRouter } from '@/i18n/navigation';
import { useLocale, useTranslations } from 'next-intl';

import { useTranslatedData } from '@/hooks/useTranslatedData';
import { useParams } from 'next/navigation';
import { useEffect, useState, useTransition } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useWindowSize } from 'react-use';
import { Dropdown } from 'rsuite';
import styles from './header-top.module.scss';

const HeaderTop = ({
  menu,
  loading,
}: {
  menu: MenuDetailsFragment | null | undefined;
  loading: boolean;
}) => {
  const locale = useLocale();
  const [switchLanguage, setSwitchLanguage] = useState<string>(locale);
  const translatedHeaderMenu = useTranslatedData(menu?.items || [], ['name']);
  const pathname = usePathname();
  const router = useRouter();
  const width = useWindowSize();
  const t = useTranslations('General');
  const [isPending, startTransition] = useTransition();
  const params = useParams();

  const handleSwitchLanguage = (language: string) => {
    isPending && console.log('Pending...');
    startTransition(() => {
      router.replace(
        // @ts-expect-error -- TypeScript will validate that only known `params`
        { pathname, params },
        { locale: language }
      );
    });
    setSwitchLanguage(language);
  };

  useEffect(() => {
    localStorage.setItem('lang', switchLanguage);
  }, [switchLanguage]);

  const renderIconButton = (props: any, ref: any) => {
    return (
      <div {...props} ref={ref} className={styles.more}>
        <span>{t('more')}</span> <IconArrow />
      </div>
    );
  };

  const hasMounted = useHasMounted();

  if (!hasMounted) return null;

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.mobileHeader}>
        <HeaderTopMobile menu={menu} loading={loading} />
      </div>
      <header className={styles.header}>
        <div className={styles.header__wrapper}>
          <div className={styles.leftSection}>
            <Link href={'/'} className={styles.logo}>
              <HeaderLogo />
            </Link>
            <div className={styles.delivery}>
              <div className={styles.city}>
                <CustomCitiesSelect />
              </div>
              <div className={styles.deliveryInfo}>{t('delivery')}</div>
            </div>
            <div className={styles.phoneNumber}>
              +998 (71) 200 31 00
              <span className={styles.schedule}>{t('schedule')}</span>
            </div>
          </div>
          <div className={styles.rightSection}>
            <div className={styles.menuItems}>
              {loading
                ? Array.from({ length: 3 }).map((_, index) => (
                    <div key={index} className={styles.skeletonForMobile}>
                      <Skeleton />
                    </div>
                  ))
                : translatedHeaderMenu
                    ?.slice(0, width.width <= 1300 ? 2 : 6)
                    .map((i, id) => (
                      <Link
                        key={id + '_' + i.name}
                        className={
                          pathname === i.url ? styles.activeLink : styles.link
                        }
                        href={i.url || '#'}
                      >
                        {i.name}
                      </Link>
                    ))}

              <div className={styles.dropdown}>
                {translatedHeaderMenu &&
                  translatedHeaderMenu.length >
                    (width.width <= 1300 ? 2 : 6) && (
                    <Dropdown
                      placement="bottomEnd"
                      renderToggle={renderIconButton}
                    >
                      {translatedHeaderMenu
                        .slice(width.width <= 1300 ? 2 : 6)
                        .map((i, id) => (
                          <Dropdown.Item
                            key={id}
                            className={styles.activeDropdown}
                            onClick={() => router.push(i.url || '#')}
                          >
                            <span
                              className={
                                pathname === i.url
                                  ? styles.activeLink
                                  : styles.link
                              }
                            >
                              {i.name}
                            </span>
                          </Dropdown.Item>
                        ))}
                    </Dropdown>
                  )}
              </div>
            </div>
            <div className={styles.languageSwitch}>
              <button
                type="button"
                onClick={() => handleSwitchLanguage('ru')}
                className={`${styles.lang} ${switchLanguage === 'ru' && styles.active}`}
              >
                Рус
              </button>
              <button
                type="button"
                onClick={() => handleSwitchLanguage('uz')}
                className={`${styles.lang} ${switchLanguage === 'uz' && styles.active}`}
              >
                O’z
              </button>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default HeaderTop;
